(() => {
  const modal = document.querySelector('[data-newsletter-modal]');
  const emailInput = document.querySelector('#NixFooterNewsletter input[type="email"]');

  emailInput?.addEventListener('input', () => emailInput.setCustomValidity(''));
  emailInput?.addEventListener('invalid', () => {
    emailInput.setCustomValidity(
      emailInput.value ? 'Please enter a valid email address, e.g. name@example.com' : ''
    );
  });

  if (!modal) return;

  const dialog = modal.querySelector('.nix-newsletter-modal__dialog');
  const dismissButtons = modal.querySelectorAll('[data-newsletter-dismiss]');
  let previousFocus;

  const openModal = () => {
    previousFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nix-newsletter-modal-open');
    dialog?.focus();
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nix-newsletter-modal-open');
    previousFocus?.focus?.();
  };

  if (modal.dataset.state === 'success') {
    openModal();
  }

  dismissButtons.forEach((button) => button.addEventListener('click', closeModal));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();
